const DARK_BACKGROUND = [17, 20, 27];
const LIGHT_BACKGROUND = [248, 247, 242];
const DARK_INK = [247, 247, 245];
const LIGHT_INK = [34, 35, 41];

// Favor colors that occupy meaningful cover area, with a modest preference
// for saturated colors over white backgrounds or monochrome portraits.
export const representativeArtworkColor = (pixels) => {
  const buckets = new Map();
  for (let index = 0; index < pixels.length; index += 4) {
    if (pixels[index + 3] < 128) continue;
    const red = pixels[index];
    const green = pixels[index + 1];
    const blue = pixels[index + 2];
    const key = ((red >> 4) << 8) | ((green >> 4) << 4) | (blue >> 4);
    const bucket = buckets.get(key) || { count: 0, red: 0, green: 0, blue: 0 };
    bucket.count += 1;
    bucket.red += red;
    bucket.green += green;
    bucket.blue += blue;
    buckets.set(key, bucket);
  }

  let bestColor = null;
  let bestScore = -1;
  // The lower RGB bucket wins ties on every client, regardless of pixel order.
  for (const key of [...buckets.keys()].sort((left, right) => left - right)) {
    const bucket = buckets.get(key);
    const color = [bucket.red, bucket.green, bucket.blue].map(value => value / bucket.count);
    const maximum = Math.max(...color);
    const saturation = maximum === 0 ? 0 : (maximum - Math.min(...color)) / maximum;
    const score = bucket.count * (1 + 2 * saturation);
    if (score > bestScore) {
      bestScore = score;
      bestColor = color;
    }
  }
  return bestColor;
};

export const previewArtworkPalette = (representativeColor, darkMode) => {
  const anchor = darkMode ? DARK_BACKGROUND : LIGHT_BACKGROUND;
  const amount = darkMode ? .28 : .18;
  return {
    background: representativeColor
      ? anchor.map((channel, index) => Math.round(channel + (representativeColor[index] - channel) * amount))
      : anchor,
    ink: darkMode ? DARK_INK : LIGHT_INK,
    mark: darkMode ? DARK_INK : LIGHT_INK,
  };
};
